import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Optional, Output} from '@angular/core';
import {ApiMessage} from './api-response.model';
import {IndividualConfig, ToastPackage, ToastrService} from 'ngx-toastr';
import {AppConfig} from "../app.config";
import {BaseComponent} from "../base-component";
import {takeUntil} from "rxjs/operators";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-api-response',
  templateUrl: './api-response.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApiResponseComponent extends BaseComponent implements OnInit {
  @Input() message: ApiMessage;
  options: IndividualConfig;
  isAutoCollapseEnabled: boolean;
  title$ = new BehaviorSubject<string>(null);
  @Input() type: string;
  @Input() count: number = 0;
  @Output() remove = new EventEmitter<ApiMessage>();
  showMore: boolean = false;
  hasMore: boolean;

  constructor(@Optional() public toastPackage: ToastPackage, private toastrService: ToastrService, @Inject('config') public config: AppConfig) {
    super();
  }

  ngOnInit(): void {
    this.type = this.toastPackage?.toastType ?? this.type;
    this.options = this.toastPackage?.config ?? this.toastrService.toastrConfig;

    this.isAutoCollapseEnabled = this.config.apiResponseCollapseEnabled;
    this.title$.next(this.toastPackage?.title);
    this.toastPackage?.toastRef.countDuplicate().pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      if (value > 0) {
        this.title$.next(`${this.toastPackage.title ?? ''} [${value}]`);
      }
    });
    this.hasMore = this.hasMoreButton();
  }

  hasMoreButton() {
    const hasModel = this.message.Model && this.message.Model !== 'null' && this.message.Model !== '{}';
    const nrOfMessages = this.message.Messages.length;
    const maxNrOfLines = this.message.Messages.sort((a, b) => {
      return (a ?? '').split('\n').length - (b ?? '').split('\n').length
    })[0]?.split('\n').length;
    const nrOfCharacters = this.message.Messages.reduce((total, message) => {
      return total + (message ?? '').length
    }, 0);
    const isLong = this.isAutoCollapseEnabled && (nrOfMessages > 10 || maxNrOfLines > this.config.apiResponseLineCollapseLimit || nrOfCharacters > 500);

    return hasModel || isLong;
  }

  isCollapsed() {
    return !this.showMore && this.hasMore && this.isAutoCollapseEnabled;
  }
}
